export const NEXT_API_PREFIX = "/api";

export const nextApiPath = (path: string): string => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${NEXT_API_PREFIX}${normalizedPath}`;
};

export const NEXT_API_DEV_LOGS_PATH = nextApiPath("/dev-logs");
